module.exports = __webpack_public_path__ + "static/media/food-carton.4181eb0c.gif";